module.exports = __webpack_public_path__ + "static/media/ag.f6adf542.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ag.svg
// module id = 45
// module chunks = 0